import type { Show } from '../types/schemas'
import { route } from 'preact-router'

interface ShowCardProps {
  show: Show
  lastWatched?: number
}

export function ShowCard({ show, lastWatched }: ShowCardProps) {
  const handleClick = () => {
    route(`/shows/${show.id}`)
  }

  const formatDate = (timestamp: number) => {
    if (!timestamp) return 'Never watched'
    const date = new Date(timestamp) // timestamp is already in milliseconds
    const now = new Date()
    const diffDays = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24))

    if (diffDays === 0) return 'Today'
    if (diffDays === 1) return 'Yesterday'
    if (diffDays < 7) return `${diffDays} days ago`
    if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`
    if (diffDays < 365) return `${Math.floor(diffDays / 30)} months ago`
    return `${Math.floor(diffDays / 365)} years ago`
  }

  return (
    <div
      onClick={handleClick}
      className="bg-slate-800 rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow cursor-pointer"
    >
      <div className="aspect-[2/3] relative overflow-hidden bg-slate-700">
        {show.image?.medium ? (
          <img src={show.image.medium} alt={show.name} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <span className="text-slate-500 text-lg">Show</span>
          </div>
        )}
      </div>

      <div className="p-4">
        <h3 className="font-semibold text-white truncate">{show.name}</h3>
        <p className="text-sm text-slate-400 mt-1">{formatDate(lastWatched || 0)}</p>
        {show.status && (
          <span
            className={`inline-block mt-2 px-2 py-1 text-xs rounded ${
              show.status === 'Running'
                ? 'bg-green-900/50 text-green-300'
                : 'bg-slate-700 text-slate-400'
            }`}
          >
            {show.status}
          </span>
        )}
      </div>
    </div>
  )
}
